// extracted by mini-css-extract-plugin
module.exports = {"container":"Waypoints_container__OcKGe","title":"Waypoints_title__NRDVo"};